document.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelector('.js-flash')

  setTimeout(() => {
    el.classList.remove('fadeOut')
    el.classList.add('fadeIn')
  }, 100)

  if (el) {
    setTimeout(() => {
      el.classList.remove('fadeIn')
      el.classList.add('fadeOut')
    }, 5000)

    setTimeout(() => el.remove(), 6000)

    document.addEventListener('click', () => {
      el.classList.remove('fadeIn')
      el.classList.add('fadeOut')
    })
  }
})
